import { cloneDeep, escape, isEqual } from 'lodash'

import { generateServices, globalErrorHandler, services } from '@/utils'

import { inputFilter, outputFilter } from '@/components/services/users/utils'

import render from './render'

export default {
  name: 'Template',

  mixins: [
    generateServices({
      name: services.users,

      inputFilter,
      outputFilter,

      find: false,
      create: false,
      remove: false,
      get: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      },
      update: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      }
    })
  ],

  data() {
    return {
      formValidation: true,
      initialData: undefined,
      updateSuccessKey: 0
    }
  },

  computed: {
    dataIsEqual() {
      return isEqual(
        this.normalizeDataForCompare(cloneDeep(this.initialData)),
        this.normalizeDataForCompare(cloneDeep(this.restData[services.users].get.data))
      )
    },
    updateDisabled() {
      return this.restData[services.users].update.state === 'loading'
        || !this.formValidation
        || this.dataIsEqual
    },
    username() {
      const data = this.restData[services.users].get.data

      return data.username
    },
    name() {
      const data = this.restData[services.users].get.data
      const { firstName, lastName } = data.data || {}

      return [ firstName, lastName ].filter(Boolean).map(escape).join(' ')
    },
    verified() {
      const data = this.restData[services.users].get.data

      return data.$verified
    }
  },

  async mounted() {
    await this.getById()
  },

  methods: {
    normalizeDataForCompare(value) {
      if (value === null || value === undefined) {
        return undefined
      }

      if (Array.isArray(value)) {
        return value
          .map(item => {
            return this.normalizeDataForCompare(item)
          })
          .filter(item => {
            return item !== undefined
          })
      }

      if (typeof value === 'object') {
        const normalizedValue = {}

        for (const key of Object.keys(value)) {
          const nextValue = this.normalizeDataForCompare(value[key])

          if (nextValue !== undefined) {
            normalizedValue[key] = nextValue
          }
        }

        return normalizedValue
      }

      return value
    },

    async getById() {
      try {
        const result = await this.rest[services.users].get(this.account.id)

        if (result) {
          this.initialData = cloneDeep(result)
        } else {
          this.initialData = undefined
        }
      } catch (error) {
        globalErrorHandler(error)
      }
    },

    async update() {
      if (this.updateDisabled) {
        return
      }

      try {
        const result = await this.rest[services.users].update(
          this.restData[services.users].get.data.id,
          this.restData[services.users].get.data
        )

        if (result) {
          this.initialData = cloneDeep(result)
          this.updateSuccessKey += 1
        }
      } catch (error) {
        globalErrorHandler(error)
      }
    }
  },

  render
}
